<div style="display:none">
  <div id="section">
    <div style="padding:2px; border: 7px ;">
      <div *ngIf="FormOfPoOrderSupplyPrint==1" class="wrapper" style="margin: 0 auto;">
        <table class="full-width ">
          <tr style="vertical-align:top;">
            <td colspan="6" class="reportTitle_ar">
              <img alt="" src="../../../../assets/images/ora/1.png" style="width:85%;margin-left: 0;height:65px;">
            </td>
            <td colspan="6" style="font-size: 35px;color: #252595;font-weight:bold;">{{ 'POORDERSUPPLY' | translate}}
              {{translate.currentLang == 'ar' ? 'رقم' : 'Number '}}
              <span>{{row.masterSerial}}</span>
            </td>
          </tr>
        </table>

        <!-- new design -->
        <div class="main_data">
          <h3 style="margin-bottom: 25px;"> {{translate.currentLang == 'ar' ? 'السادة شركة / ' : 'Company/ '}}
            <span>{{row.supplierNameAr}}</span>
          </h3>
          <p class="lead"> {{translate.currentLang == 'ar' ? 'تحية طيبة وبعد,,,,,, ' : 'After Greetings,,,,,,/ '}}</p>

          <p class="lead"> {{translate.currentLang == 'ar' ? ' برجاء من سيادتكم توريد الاصناف التالية الى ' : ' Please,
            your honor,supply the following items to pharmacy '}}
            <span>{{row?.nameAr}}</span> <span>
              {{translate.currentLang == 'ar' ? 'ب' : ' '}}{{row?.hospitalNameAr}}</span>
            {{translate.currentLang == 'ar' ? 'من خلال الموزع ' : 'through distributor '}}

          </p>
          <p class="lead"> {{translate.currentLang == 'ar' ? 'وذلك حسب الاتفاق المبرم بيننا وبين سيادتكم:-' : 'This is
            according to the agreement concluded between us and you:- '}}
          </p>
        </div>
        <table class="full-width">
          <tbody>

            <tr>
              <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: underline;">{{'REQUESTORDER' |
                  translate}}</strong></td>
              <td class="groupHeaderDataCell_ar">{{ row?.regDate | date :'short'}}</td>
            </tr>
            <tr>
              <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: underline;">{{'CODE' |
                  translate}}</strong></td>
              <td class="groupHeaderDataCell_ar">{{row?.masterSerial}}</td>

              <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: underline;">{{'USER' |
                  translate}}</strong></td>
              <td class="groupHeaderDataCell_ar">{{translate.currentLang == 'ar' ? row?.userName : row?.userName}}</td>
            </tr>

            <tr>
              <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: underline;">{{'STORE' |
                  translate}}</strong></td>
              <td class="groupHeaderDataCell_ar">{{translate.currentLang == 'ar' ? row?.nameAr : row?.nameEn}}</td>
              <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: underline;">{{'TOTALDISCOUNTONTRANS' |
                translate}}</strong></td>
            <td class="groupHeaderDataCell_ar">{{row?.discountOfMaster}}</td>
            </tr>
            <tr>
              <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: underline;">{{'TOTALBEFORTAX' |
                  translate}}</strong></td>
              <td class="groupHeaderDataCell_ar">
                {{totals?.totalCostBeforTax}}
              </td>
              <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: underline;">{{'TOTALAFTERTAX' |
                  translate}}</strong>

                {{totals?.totalCostAfterTax}}</td>
              <td class="groupHeaderDataCell_ar"></td>
            </tr>
          </tbody>
        </table>
        <div class="items_data" style="margin-top: 25px;">
          <table class="full-width text-center" dir="ltr">
            <tr>
              <!-- <td class="groupHeaderLevel1_ar">{{'BALANCEANTHERSTORE' | translate}}</td> -->
              <!-- <td class="groupHeaderLevel1_ar">الرصيد</td> -->
              <td class="groupHeaderLevel1_ar">{{translate.currentLang == 'ar' ? 'اجمالى بعدالضريبة' : 'Total After
                Tax'}}</td>
              <td class="groupHeaderLevel1_ar"> {{translate.currentLang == 'ar' ? 'اجمالى الضريبة' : 'Total Tax'}}</td>
              <td class="groupHeaderLevel1_ar">{{translate.currentLang == 'ar' ? 'اجمالى التكلفه' : 'Total Cost'}}</td>
              <td class="groupHeaderLevel1_ar" *ngIf="poOrderType!==3">{{translate.currentLang == 'ar' ? 'سعر الوحده' :
                'Unit Price'}}</td>
              <td class="groupHeaderLevel1_ar" *ngIf="poOrderType==3">{{translate.currentLang == 'ar' ? 'سعر الاصل' :
                'Asset Price'}}</td>

              <td class="groupHeaderLevel1_ar">{{translate.currentLang == 'ar' ? 'الكمية' : 'Count'}}</td>
              <td class="groupHeaderLevel1_ar" *ngIf="poOrderType!==3">{{translate.currentLang == 'ar' ? 'الوحدات' :
                'Units'}}</td>
              <td class="groupHeaderLevel1_ar" *ngIf="poOrderType==3">{{translate.currentLang == 'ar' ? 'الاصل المشابه'
                :
                'Similar Asset'}}</td>
              <td class="groupHeaderLevel1_ar" *ngIf="poOrderType==3">
                {{'Notes' | translate}}
              </td>
              <td class="groupHeaderLevel1_ar">{{translate.currentLang == 'ar' ? 'اسم الصنف' : 'Product Name'}}</td>
              <td class="groupHeaderLevel1_ar"> {{translate.currentLang == 'ar' ? 'كود الصنف' : 'Product ID'}}</td>
              <td class="groupHeaderLevel1_ar">{{translate.currentLang == 'ar' ? 'المسلسل' : 'Series'}} </td>
            </tr>
            <tbody>
              <tr *ngFor="let item of items; index as i">
                <!-- <td class="detailBand_ar"><b>{{ item.balanceAntherStore }}</b></td> -->
                <!-- <td class="detailBand_ar" style="direction: rtl;"><b>{{ item.cardBalanceDiscription }}</b></td> -->
                <td class="detailBand_ar" style="direction: rtl;"><b>{{ item.netOfPiceUnits + item.tax }}</b></td>
                <td class="detailBand_ar" style="direction: rtl;"><b>{{ item.tax }}</b></td>
                <td class="detailBand_ar" style="direction: rtl;"><b>{{ item.netOfPiceUnits }}</b></td>
                <td class="detailBand_ar"><b>{{ item.unitPrice }}</b></td>
                <td class="detailBand_ar"><b>{{ item.quantity }}</b></td>

                <td class="detailBand_ar" *ngIf="poOrderType!==3"><b>{{ item.unitNameAr }}</b></td>
                <td class="detailBand_ar" *ngIf="poOrderType ==3"><b>{{translate.currentLang == 'ar' ?
                    item.assetsMainDataAr : item.assetsMainDataEn}}</b></td>
                <td class="detailBand_ar" *ngIf="poOrderType==3"><b>{{ item.notes }}</b></td>


                <td class="detailBand_ar"><b>{{ item.nameAr }}</b></td>
                <td class="detailBand_ar"><b>{{ item.customID }}</b></td>
                <td class="detailBand_ar"><b>{{ i+1 }}</b></td>
              </tr>
            </tbody>
          </table>
        </div>
        <table class="full-width" style="text-align: center;margin-top: 60px;">
          <tbody>

            <tr>
              <td class=""><strong>
                  {{translate.currentLang == 'ar' ? 'مدير المخازن' : 'Stores Manager '}}
                </strong></td>
              <td class=""><strong> {{translate.currentLang == 'ar' ? 'مدير المشتريات' : 'Purchases Manager '}}
                </strong></td>
              <!-- <td class="" *ngIf="poOrderType==3"><strong>{{'manger' | translate}} <span>{{row?.nameAr}}</span></strong>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <!-- mmc -->
      <div *ngIf="FormOfPoOrderSupplyPrint==2" class="wrapper" style="margin: 0 auto;">
        <table class="full-width ">
          <tr style="vertical-align:top;">
            <div style="display: flex;align-items: center;">
              <h3 class="reportTitle_ar" colspan="3" style="margin: auto;"> PURCHASE ORDER </h3>
              <div>
                <h3 class="reportTitle_ar" colspan="3" style="margin: auto;"> PURCHASE ORDER </h3>
              </div>
              <img alt="" src="../../../../assets/images/ora/logo{{row.branchId}}.png"
                style="width:45%;margin-left: 0;height:65px;">
            </div>
        </table>
        <!-- <table class="full-width">
          <tbody> 
            <tr>
              <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: underline;">{{'TRANSDATE' |
                  translate}}</strong></td>
              <td class="groupHeaderDataCell_ar">{{row.transDate | date :'short'}}</td>
            </tr>
            <tr>
              <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: underline;">{{'TransCode' |
                  translate}}</strong></td>
              <td class="groupHeaderDataCell_ar">{{row.masterSerial}}</td>

              <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: underline;">{{'USER' |
                  translate}}</strong></td>
              <td class="groupHeaderDataCell_ar">
                {{translate.currentLang == 'ar' ? row.userName : row.userName}}
              </td>
            </tr> 
            <tr>
              <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: underline;">{{'STORE' |
                  translate}}</strong></td>
              <td class="groupHeaderDataCell_ar">
                {{translate.currentLang == 'ar' ? row.nameAr : row.nameEn}}
              </td>

              <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: underline;">{{'SUPPLIER' |
                  translate}}</strong></td>
              <td class="groupHeaderDataCell_ar">
                {{translate.currentLang == 'ar' ? row.supplierNameAr : row.supplierNameEn}}
              </td> 
            </tr> 
            <tr>
              <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: underline;">{{'BENEFICIARYCODE' |
                  translate}}</strong></td>
              <td class="groupHeaderDataCell_ar">{{row.beneficiaryCode}}</td>
              <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: underline;">{{'Beneficiary' |
                  translate}}</strong></td>
              <td class="groupHeaderDataCell_ar">{{translate.currentLang == 'ar' ? row.supplierNameAr :
                row.supplierNameEn}}</td>
            </tr> 
            <tr>
              <td class="groupHeaderLabelCell_ar" [hidden]="false"><strong
                  style="text-decoration: underline;">{{'TOTALCOST' | translate}}</strong></td>
              <td class="groupHeaderDataCell_ar" [hidden]="false">
                {{ row.netOfPiceUnits}}</td>
              <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: underline;">{{'TOTALSALE' |
                  translate}}</strong></td>
              <td class="groupHeaderDataCell_ar">{{ row.totalPoValue }}</td>
            </tr>
            <tr>
              <td class="groupHeaderLabelCell_ar"><strong style="text-decoration: underline;">{{'NOTE' |
                  translate}}</strong></td>
              <td class="groupHeaderDataCell_ar">{{row.notes}}</td>
            </tr>
          </tbody>
        </table> -->
        <!-- -------------------master------------------------- -->
        <table class="full-width" style="width: 100%;direction: ltr;text-align: left;">
          <tbody>
            <tr>
              <td colspan="5" style="text-align: center;" class="detailBand_ar">Order#</td>
              <td colspan="14" style="text-align: center;font-size: 18px;font-weight:bold" class="detailBand_ar">
                <!-- <input type="text" class="form-control"
                  style="border-right:none;border-left: none;border-top: none;width: 170px;" /> -->
                {{row.masterSerial}}
              </td>
              <td style="text-align: center;" colspan="0" class="detailBand_ar">
                تعميد رقم
              </td>
            </tr>
            <tr>
              <td colspan="5" style="text-align: center;" class="detailBand_ar">QUOTE#
              </td>
              <td colspan="14" style="text-align: center;" class="detailBand_ar">
                <input type="text" class="form-control"
                  style="border-right:none;border-left: none;border-top: none;width: 170px;" />
              </td>
              <td colspan="0" style="text-align: center;" class="detailBand_ar">
                عرض سعر رقم
              </td>
            </tr>
            <tr>
              <td colspan="4" style="text-align: center;" class="detailBand_ar">Supplier
              </td>
              <td colspan="12" style="text-align: center;" class="detailBand_ar">{{translate.currentLang == 'ar' ?
                row.supplierNameAr :
                row.supplierNameEn}}</td>
              <td style="text-align: center;" colspan="1" class="detailBand_ar">
                Ship to:
              </td>
              <td style="text-align: center;" colspan="1" class="detailBand_ar">
                MMC2
              </td>
              <td style="text-align: center;" colspan="3" class="detailBand_ar">
                Date : {{row.transDate | date :'short'}}
              </td>
            </tr>
            <tr>
              <td style="text-align: center;" colspan="4" class="detailBand_ar">CODE
              </td>
              <td style="text-align: center;" colspan="10" class="detailBand_ar">
                {{row.beneficiaryCode}}
              </td>
              <td style="text-align: center;" colspan="6" rowspan="2" class="detailBand_ar">
                MADINAH MADICAL CENTER CO. BULDING NO 3687 ABI ZAR AL GHAFARI ST.
                BANI HARITAH DIST.AL MADINAH AL MUNAWARAH ZIP CODE 42313-
                SUPLIMENTAL # 9225. K.S.A </td>
            </tr>
            <tr>
              <td style="text-align: center;" colspan="4" class="detailBand_ar">DEPARTMENT
              </td>
              <td style="text-align: center;" colspan="8" class="detailBand_ar">{{ row.nameEn}}</td>
            </tr>
            <tr>
              <td style="text-align: center;" colspan="5" class="detailBand_ar">Attention
              </td>
              <td colspan="5" class="detailBand_ar">
                <input type="text" class="form-control"
                  style="border-right:none;border-left: none;border-top: none;width: 170px;" />
              </td>
              <!-- <td style="text-align: center;" colspan="9" class="detailBand_ar">
                khizar@madinahclinic.com
              </td> -->
              <td style="text-align: center;" colspan="5" class="detailBand_ar">
                920-002-077
              </td>
            </tr>
            <tr>
              <td style="text-align: center;" colspan="4" class="detailBand_ar">Contact
              </td>
              <td colspan="10" class="detailBand_ar">
                <input type="text" class="form-control"
                  style="border-right:none;border-left: none;border-top: none;width: 170px;" />
              </td>
              <td style="text-align: center;" colspan="1" class="detailBand_ar">
                Warehouse Contact
              </td>
              <td colspan="4" class="detailBand_ar">
              </td>
              <td colspan="3" class="detailBand_ar">
              </td>
            </tr>
            <tr>
              <td style="text-align: center;" colspan="4" class="detailBand_ar">Email
              </td>
              <td colspan="10" class="detailBand_ar">
                <input type="text" class="form-control"
                  style="border-right:none;border-left: none;border-top: none;width: 170px;" />
              </td>
              <td style="text-align: center;" colspan="4" class="detailBand_ar">
                Payment Terms
              </td>
              <td style="text-align: center;" colspan="2" class="detailBand_ar">
                <input type="text" class="form-control"
                  style="border-right:none;border-left: none;border-top: none;width: 170px;" />
              </td>
            </tr>
        </table>
        <!-- details -->
        <table class="full-width" style="width: 100%;direction: ltr;">
          <tr style="text-align: center;">
            <td style="width: 8%;" class="groupHeaderLevel1_ar">{{'No.' | translate}}</td>
            <td style="width: 6%;" class="groupHeaderLevel1_ar">{{'Code' | translate}}</td>
            <td style="width: 35%;" class="groupHeaderLevel1_ar">{{'Item Description' | translate}}
            </td>
            <td class="groupHeaderLevel1_ar">
              {{'QTY' | translate}}
            </td>
            <td class="groupHeaderLevel1_ar">
              {{'U/M' | translate}}
            </td>
            <td class="groupHeaderLevel1_ar">
              {{'Unit Price' | translate}}
            </td>
            <td class="groupHeaderLevel1_ar">
              {{'TotalPrice' | translate}}</td>
          </tr>
          <tbody>
            <tr *ngFor="let item of items" style="text-align: center;">
              <td class="detailBand_ar">{{item.rowNumber}}</td>
              <td class="detailBand_ar">{{item.customID}}</td>
              <td class="detailBand_ar">
                {{translate.currentLang == 'ar' ? item.nameAr : item.nameEn}}</td>
              <td class="detailBand_ar">
                {{item.number}}
              </td>
              <td class="detailBand_ar">
                EA
              </td>
              <td class="detailBand_ar">
                <span style="margin-right: 10px;"></span><span>{{item.unitPrice}}</span>
              </td>
              <td class="detailBand_ar">
                <span style="text-align: center"></span><span>{{item.totalCostWithTax}}</span>
              </td>
            </tr>
            <tr>
              <td sstyle="text-align: center;" colspan="2" class="detailBand_ar">MANUFACTURE:
                <input type="text" class="form-control"
                  style="border-right:none;border-left: none;border-top: none;width: 170px;" />
              </td>
              <td colspan="4" class="detailBand_ar" style="border-bottom: none;text-align: center;">
                Sub Total
              </td>
              <td colspan="5" class="detailBand_ar" style="border-bottom: none;text-align: center;">
                {{totals.totalCostBeforTax}}
              </td>
            </tr>
            <tr>
              <td style="text-align: center;" colspan="2" class="detailBand_ar">DELIEVERY TIME:
                <input type="text" class="form-control"
                  style="border-right:none;border-left: none;border-top: none;width: 170px;" />

              </td>
              <td colspan="4" class="detailBand_ar" style="border-bottom: none;;text-align: center;">VAT%</td>
              <td colspan="5" class="detailBand_ar" style="border-bottom: none;text-align: center;">
                {{row.poTotalTaxMoney}}
              </td>
            </tr>
            <tr>
              <td colspan="2" rowspan="2" class="detailBand_ar" style="text-align: center;">
                <input type="text" class="form-control"
                  style="border-right:none;border-left: none;border-top: none;width: 170px;" />
              </td>
              <td colspan="4" class="detailBand_ar" style="border-bottom: none;">VAT Value </td>
              <td colspan="5" class="detailBand_ar" style="border-bottom: none;text-align: center;">
                {{totals.totalTax}}
              </td>
            </tr>
            <tr>
              <td colspan="4" class="detailBand_ar">Contract Total Amount
              </td>
              <td colspan="5" class="detailBand_ar" style="text-align: center;">
                {{totals.totalCostAfterTax}}
                <!-- {{row.totalPoValue}} -->
                <!-- <input type="text" [value]="totals.totalCostAfterTax" class="form-control"
                  style="border-right:none;border-left: none;border-top: none;width: 170px;" /> -->
              </td>
            </tr>
            <tr>
              <td colspan="8"></td>
            </tr>
          </tbody>
        </table>
        <div style="margin: 10px;margin-top: -15px;font-size: 11px;">
          <div style="direction: ltr;">
            <div><strong style="text-decoration: none;">Terms & Conditions:</strong></div>
            <div>1. The inv. Will be paid aŌer receiving the complete supplies in hospital
            </div>
            <div>2. Payment will not be done without verification and stamped by the mtm
              manager on original invoices
            </div>
            <div>3. Attach photocopy of P.O. with original invoice</div>
            <div>4. Items will not be accepted if it has less than one year expiry</div>
          </div>
          <div style="direction: rtl;">
            <div>ـ يسري استحقاق قيمة الفاتورة بعد توريد كامل الاصناف للمجمع</div>
            <div>ـ لا تعتمد المحاسبة إلا بأصول الفواتير بعد ختمها بختم الاستلام من مسئول
              المستودع </div>
            <div>ـ يتم ارسال صورة امر الشراء مرفقا مع اصل الفاتورة</div>
            <div> لا تستقبل اصناف صلاحيتها اقل من عام</div>
          </div>
          <table class="full-width" style="text-align: center;">
            <tbody>
              <div style="direction: ltr;">
                <strong style="text-decoration: none;">Approved By: </strong>
              </div>
              <tr>
                <td class="">
                  <strong style="text-decoration: none;">/MR</strong>
                </td>
                <td class="">
                  <strong style="text-decoration: none;">/MR</strong>
                </td>
              </tr>
              <tr>
                <td class="">
                  <strong style="text-decoration: none;">PROCUREMENT MANAGER</strong>
                </td>
                <td class="">
                  <strong style="text-decoration: none;">WAREHOUSES SUPERVISOR </strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- sigal -->
      <div *ngIf="FormOfPoOrderSupplyPrint==3" class="wrapper" style="margin: 0 auto;">
        <table class="full-width ">
          <tr style="vertical-align:top; text-align: center; ">
            <td colspan="6" class="reportTitle_ar">
              <img alt="" src="../../../../assets/images/ora/1.png" style="width:85%;margin-left: 0;height:65px;">
            </td>
          </tr>
          <tr style="vertical-align:top; text-align: center;">
            <td colspan="6">{{'PURCHASE ORDER' | translate}}</td>
          </tr>
        </table>
        <!-- -------------------master------------------------- -->
        <table class="full-width">
          <tbody>
            <tr>
              <td colspan="2" class="groupHeaderLabelCell_ar"><strong style="text-decoration: none !important;">{{'P.O.
                  No: ' |
                  translate}}</strong></td>
              <td class="groupHeaderDataCell_ar">{{row.masterSerial}}</td>
              <td colspan="2" class="groupHeaderLabelCell_ar"><strong
                  style="text-decoration: none !important;;">{{'Date:
                  ' | translate}}</strong></td>
              <td class="groupHeaderDataCell_ar">{{row.transDate | date :'dd-MM-yyyy'}}</td>
            </tr>
            <tr>
              <td colspan="2" class="groupHeaderLabelCell_ar"><strong
                  style="text-decoration: none !important;;">{{'Company Name: ' | translate}}</strong></td>
              <td colspan="4" class="groupHeaderDataCell_ar">
                شركة عالم سيجال
              </td>
            </tr>
            <tr *ngIf="StrOfferPrice.length>0">
              <td colspan="2" class="groupHeaderLabelCell_ar"><strong
                  style="text-decoration: none !important;;">{{'Quotation No: ' | translate}}</strong></td>
              <td colspan="4" class="groupHeaderDataCell_ar">
                {{StrOfferPrice[0]?StrOfferPrice[0].code:0}}
              </td>
              <td colspan="2" class="groupHeaderLabelCell_ar"><strong
                  style="text-decoration: none !important;;">{{'Quotation Date: ' | translate}}</strong></td>
              <td class="groupHeaderDataCell_ar">{{StrOfferPrice[0]?StrOfferPrice[0].regDate: '' | date :'dd-MM-yyyy'}}
              </td>
            </tr>
            <tr>
              <td colspan="2" class="groupHeaderLabelCell_ar"><strong
                  style="text-decoration: none !important;;">{{'Contact person: ' |
                  translate}}</strong></td>
              <td colspan="4" class="groupHeaderDataCell_ar">{{translate.currentLang == 'ar' ? row.supplierNameAr :
                row.supplierNameEn}}
              </td>
            </tr>
          </tbody>
        </table>
        <div style="margin: 10px;margin-top: -15px;font-size: 11px;">
          <div style="direction: ltr;">
            <div><strong style="text-decoration: none;">Terms & Conditions:</strong></div>
            <div>1. Deliver the item to our warehouse located in Haer along with the copy of each individual purchase
              order, invoice and delivery note.
            </div>
            <div>2. Attach the company bank details with IBAN number as personal bank account is not allowed for
              payment.
            </div>
            <div>3. Include the company VAT registration certificate.</div>
            <div>4. The execution of due payment will be processed within 30-45 working days.</div>
            <div>5. Rejected items should be considered and deducted from invoice.</div>
            <div>6. Warranty of items should be issued during delivery if applicable.</div>
          </div>
          <div style="direction: ltr;">
            <div><strong style="text-decoration: none;">Purchased Items</strong></div>
          </div>
          <!-- details PO -->
          <table class="full-width" style="width: 100%;direction: ltr;">
            <tr style="text-align: center;">
              <td style="width: 8%;" class="groupHeaderLevel1_ar">{{'Sr' | translate}}</td>
              <td style="width: 8%;" class="groupHeaderLevel1_ar">{{'Item desc' | translate}}</td>
              <td style="width: 8%;" class="groupHeaderLevel1_ar">{{'Manufacturer' | translate}}</td>
              <td style="width: 8%;" class="groupHeaderLevel1_ar">{{'Catalog Number' | translate}}</td>
              <td style="width: 6%;" class="groupHeaderLevel1_ar">{{'UOM' | translate}}</td>
              <td style="width: 6%;" class="groupHeaderLevel1_ar">{{'Qty' | translate}}</td>
              <td style="width: 6%;" class="groupHeaderLevel1_ar">{{'Unit Price' | translate}}</td>
              <td style="width: 6%;" class="groupHeaderLevel1_ar">{{'VAT' | translate}}</td>
              <td style="width: 6%;" class="groupHeaderLevel1_ar">{{'Total' | translate}}</td>
            </tr>
            <tbody>
              <tr *ngFor="let item of items" style="text-align: center;">
                <td class="detailBand_ar">{{item.customID}}</td>
                <td class="detailBand_ar">
                  {{translate.currentLang == 'ar' ? item.nameAr : item.nameEn}}</td>
                <td class="detailBand_ar">
                  {{item.manufacturing}}
                </td>
                <td class="detailBand_ar">
                  {{item.technicalSpecifications}}
                </td>
                <td class="detailBand_ar">
                  {{translate.currentLang == 'ar' ? item.unitNameAr : item.unitNameEn}}
                </td>
                <td class="detailBand_ar">
                  {{ item.number}}
                </td>
                <td class="detailBand_ar">
                  <span style="margin-right: 10px;"></span><span>{{item.unitPrice}}</span>
                </td>
                <td class="detailBand_ar">
                  <span style="text-align: center"></span><span>{{item.totalTax}}</span>
                </td>
                <td class="detailBand_ar">
                  <span style="text-align: center"></span><span>{{item.totalCostAfterTax}}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div style="direction: ltr;">
            <div>-Sigal World of Medical Services</div>
            <div>-Store Keeper: Faisal, Mobile Number: +966530141964</div>
            <div>-Process Flow: Procurement -> Finance -> Top management if necessary -> Procurement -> Supplier</div>
            <div>-Note: The P.O. will be filed by blank and a copy will be given to blank.</div>
          </div>
          <div style="direction: ltr;">
            <div><strong style="text-decoration: none;">Promo Items</strong></div>
          </div>
          <!-- details OFFER-->
          <table *ngIf="StrOfferPrice.length>0" class="full-width" style="width: 100%;direction: ltr;">
            <tr style="text-align: center;">
              <td style="width: 8%;" class="groupHeaderLevel1_ar">{{'Sr' | translate}}</td>
              <td style="width: 8%;" class="groupHeaderLevel1_ar">{{'Item desc' | translate}}</td>
              <td style="width: 8%;" class="groupHeaderLevel1_ar">{{'Manufacturer' | translate}}</td>
              <td style="width: 8%;" class="groupHeaderLevel1_ar">{{'Catalog Number' | translate}}</td>
              <td style="width: 6%;" class="groupHeaderLevel1_ar">{{'UOM' | translate}}</td>
              <td style="width: 6%;" class="groupHeaderLevel1_ar">{{'Qty' | translate}}</td>
              <td style="width: 6%;" class="groupHeaderLevel1_ar">{{'Unit Price' | translate}}</td>
              <td style="width: 6%;" class="groupHeaderLevel1_ar">{{'VAT' | translate}}</td>
              <td style="width: 6%;" class="groupHeaderLevel1_ar">{{'Total' | translate}}</td>
            </tr>
            <tbody>
              <tr *ngFor="let item of StrOfferPrice" style="text-align: center;">
                <td class="detailBand_ar">{{item.customID}}</td>
                <td class="detailBand_ar">
                  {{translate.currentLang == 'ar' ? item.nameAr : item.nameEn}}</td>
                <td class="detailBand_ar">
                  {{item.manufacturing}}
                </td>
                <td class="detailBand_ar">
                  {{item.technicalSpecifications}}
                </td>
                <td class="detailBand_ar">
                  {{translate.currentLang == 'ar' ? item.unitNameAr : item.unitNameEn}}
                </td>
                <td class="detailBand_ar">
                  {{ item.itemCount}}
                </td>
                <td class="detailBand_ar">
                  <span style="margin-right: 10px;"></span><span>{{item.unitPrice}}</span>
                </td>
                <td class="detailBand_ar">
                  <span style="text-align: center"></span><span>{{item.totalTax}}</span>
                </td>
                <td class="detailBand_ar">
                  <span style="text-align: center"></span><span>{{item.totalCostAfterTax}}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="full-width" style="text-align: center;">
            <tbody>
              <tr style="line-height: 75px;">
                <td class="">
                  <strong style="text-decoration: none;">Procurement Officer </strong>
                </td>
                <td class="">
                  <strong style="text-decoration: none;">Procurement Manager </strong>
                </td>
                <td class="">
                  <strong style="text-decoration: none;">Reviewed by Finance </strong>
                </td>
              </tr>
              <tr style="line-height: 75px;">
                <td style="text-align: center;">
                  <strong style="text-decoration: none;"> </strong>
                </td>
                <td style="text-align: center;">
                  <strong style="text-decoration: none;">Approved (Name and Title) </strong>
                </td>
                <td style="text-align: center;">
                  <strong style="text-decoration: none;"> </strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<app-print-page #printComponent section="section"></app-print-page>